import ScriptHelper from "base/ScriptHelper";
import AbstractVideo from "video/AbstractVideo";

export default class VimeoVideo extends AbstractVideo {
    constructor(data, $element, settings = {}) {
        super(data, $element, settings);

        this.initialisePlayer();
    }

    play() {
        this.player.play();
    }

    pause() {
        this.player.pause();
    }

    stop() {
        this.player.unload();
    }

    seek(time) {
        this.player.setCurrentTime(time);
    }

    setVolume(volume) {
        this.player.setVolume(volume);
    }

    initialisePlayer() {
        ScriptHelper.load_script('https://player.vimeo.com/api/player.js').then(() => {
            let player = this.player = new Vimeo.Player(this.$element[0], {
                id: this.video_id,
                autoplay: this.settings.autoplay,
                byline: false,
            });

            player.on("ended", () => this.emit("ended"));
            player.on("loaded", () => this.emit("loaded"));
            player.on("play", () => this.emit("play"));
            player.on("pause", () => this.emit("pause"));
        }).catch((e) => {
            console.error("Couldn't load Vimeo player API", e);
        });
    }

    destroy() {
        super.destroy();

        //There isn't really a destroy method for vimeo, the best we can do is unload and release the object
        this.stop();
        this.player = null;

        this.$element.html("");
        this.$element.removeAttr("data-vimeo-initialized");
        this.$element.removeData("vimeoInitialized");
    }

    static get_video_details(videoId) {
        return new Promise((resolve, reject) => {
            this.updatePreviewAjax = $.ajax({
                url: "https://api.vimeo.com/videos/" + videoId,
                headers: {
                    Authorization: "Bearer " + window.CONFIG.gallery.vimeoKey,
                },
                dataType: "json",
            }).done((data) => {
                resolve({
                    id: videoId,
                    name: data.name,
                    duration: ValueHelper.format_time(data.duration),
                    image: data.pictures.sizes[4].link,
                    provider: "vimeo.com",
                });
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown === "Not Found" ? "Invalid video url" : "Connection error");
            });
        });
    }
}

